import { query } from '@/utils/request';

// 托收明细分页查询
export async function getCollectionDetailsList(data) {
  return query('/zlb/api/pay/tuoshou/page', {
    data,
    method: 'POST',
  });
}

// 单位账户配置 获取
export async function requestBankCardList(data) {
  return query('/zlb/api/pay/bankCard/org/list', {
    method: 'POST',
    data,
  });
}

// 查询单位集团子账户对应的科目
export async function getGroupAccountSubject(params) {
  return query('/zlb/budget/account/subject/list/group-account-subject', {
    params,
  });
}

// 查询单位托收账户对应的科目
export async function getTuoshouAccountSubject(params) {
  return query('/zlb/budget/account/subject/list/tuoshou-account-subject', {
    params,
  });
}
// 单位账户余额同步
export async function syncBalanceAccount(data) {
  return query('/zlb/api/pay/tuoshou/balance/sync', {
    data,
    method: 'POST',
  });
}
// 预算科目列表
export async function getBudgetAccountSubjectList(params) {
  const currentYear = new Date().getFullYear();
  const data = {
    year: currentYear,
    ...params,
  };
  return query('/zlb/budget/account/subject/list-tree', {
    data,
    method: 'POST',
  });
}

/**
 *
 * 列表查询
 *
 */
// 托收扣款凭证
export async function getDebitNoteList(data) {
  return query('/zlb/api/search/page/debit-note', { method: 'POST', data });
}

// 新版新增接口
// 扣款凭证列表，新版
export async function getDebitNoteListNew(data) {
  return query('/zlb/api/search/page/debit-note-new', { method: 'POST', data });
}
// 代扣还款个人列表
export async function getAutomaticDeductionList(data) {
  return query('/zlb/api/search/page/automatic_deduction', { method: 'POST', data });
}

// 托收扣款（单位）列表
export async function getTransferRepaymentList(data) {
  return query('/zlb/api/search/page/transfer_repayment', { method: 'POST', data });
}

/**
 * 单据增删改查等操作使用同一套接口，仅formType不同，取值如下
 *
 * 托收扣款凭证 - CARRY_PAYMENT_FORM
 * 代扣还款个人 - AUTOMATIC_DEDUCTION_FORM
 * 托收扣款（单位） - TRANSFER_REPAYMENT_FORM
 */

// 单据初始化
export async function smallTransferInit(data) {
  return query('/zlb/api/expense/small-transfer/init', { method: 'POST', data });
}

// 保存
export async function saveSmallTransfer(data) {
  return query('/zlb/api/expense/small-transfer/save', { method: 'POST', data });
}

// 提交
export async function submitSmallTransfer(data) {
  return query('/zlb/api/expense/small-transfer/submit', { method: 'POST', data });
}
// 删除
export async function deleteSmallTransfer(data) {
  return query('/zlb/api/expense/small-transfer/delete', { method: 'POST', data });
}
//作废
export async function disCardSmallTransfer(data) {
  return query('/zlb/api/expense/rest/invalid', { method: 'POST', data });
}
// 获取详情
export async function getSmallTransferDetail(params) {
  return query('/zlb/api/expense/small-transfer/detail', { params });
}
// 获取银行回单列表
export async function getBankReiceiptList(params) {
  return query('/zlb/api/expense/small-transfer/list/associate-bank-receipt', { params });
}
// 使用模板
export async function useTemplate(data) {
  return query('/zlb/api/expense/small-transfer/detail/template/apply', { method: 'POST', data });
}

/**
 * 托收结转支付申请
 */

/**
 * 子账户结转
 */

// 结转支付查询列表
export async function getCarryOverPaymentList(data) {
  return query('/zlb/api/search/page/carry-payment', { method: 'POST', data });
}

// 小额托收的批量获取
export async function batchGetDebitNoteList(data) {
  return query('/zlb/api/expense/small-transfer/list/debit-note', { method: 'POST', data });
}

// 统计未被使用的托付扣款凭证 - 废弃，通过查询未关联结转凭证请求获取相关数据
// export async function getSmallTransferNotUse(data) {
//   return query('/zlb/api/expense/small-transfer/statistic/not-use', { method: 'POST', data });
// }

// 获取小额托收配置
export async function getCarryOverPaymentConfig(data) {
  return query('/zlb/api/expense/carry-payment/config', { method: 'POST', data });
}

// 获取小额托收配置的科目
export async function getCarryOverPaymentConfigSubjects(data) {
  return query('/zlb/api/expense/budget-project/tenant/subject/query', { method: 'POST', data });
}

// 小额托收总览
export async function getCarryOverPaymentOverview(data) {
  return query('/zlb/api/expense/small-transfer/collection/statis/view', { method: 'POST', data });
}

// 获取新版托收关联会计科目
export async function getAccountSubject(data) {
  return query('/zlb/budget/account/subject/list-account-subject', { method: 'POST', data });
}

// 初始化单位托收
export async function initUnitCollection(data) {
  return query('/zlb/api/expense/expense-form/init-expense-form/transfer-repayment', {
    method: 'POST',
    data,
  });
}
